export enum RelEnum {
  REL_CURRENT = 'current',
  REL_PREV = 'prev',
  REL_NEXT = 'next',
}
